// Reglas de adjuntos (decisiones del 13-oct-2026):
//  · máximo 20 MB por archivo; se bloquean ejecutables y scripts
//  · un adjunto puede marcarse como sensible (recibos, layouts con salarios, datos personales):
//    solo lo ven el agente asignado, los líderes de servicio y el admin; cada descarga se audita
//  · los sensibles se borran solos 180 días después de cerrar el ticket (LFPDPPP)
export const MAX_ATTACHMENT_BYTES = 20 * 1024 * 1024;
export const SENSITIVE_RETENTION_DAYS = 180;
const BLOCKED_EXTENSIONS = new Set([
    'exe', 'bat', 'cmd', 'com', 'msi', 'scr', 'ps1', 'vbs', 'vbe', 'js', 'jse', 'wsf', 'wsh',
    'jar', 'sh', 'app', 'dmg', 'pif', 'cpl', 'hta', 'lnk', 'reg', 'dll'
]);
export const extensionOf = (name) => (name.toLowerCase().match(/\.([a-z0-9]+)$/)?.[1] ?? '');
export function checkAttachment(name, size) {
    if (!name.trim() || name.length > 200 || /[\\/\0]/.test(name))
        return 'BAD_NAME';
    if (size <= 0)
        return 'EMPTY';
    if (size > MAX_ATTACHMENT_BYTES)
        return 'TOO_LARGE';
    if (BLOCKED_EXTENSIONS.has(extensionOf(name)))
        return 'BLOCKED_TYPE';
    return null;
}
export const ATTACHMENT_PROBLEM_MESSAGE = {
    EMPTY: 'El archivo está vacío',
    TOO_LARGE: 'El archivo pasa de 20 MB',
    BLOCKED_TYPE: 'Por seguridad no se aceptan ejecutables ni scripts',
    BAD_NAME: 'Nombre de archivo inválido'
};
/** ¿Puede ver y descargar un adjunto sensible? */
export function canSeeSensitive(role, actorId, assigneeId) {
    return role === 'admin' || role === 'team_lead' || (assigneeId !== null && actorId === assigneeId);
}
/** ¿Puede cambiar la marca de sensible? Quien lo subió, líderes y admin. */
export function canMarkSensitive(role, actorId, uploaderId) {
    return role === 'admin' || role === 'team_lead' || actorId === uploaderId;
}
/** Fecha a partir de la cual se borra un adjunto sensible de un ticket cerrado. */
export function sensitivePurgeDate(closedAt) {
    return new Date(closedAt.getTime() + SENSITIVE_RETENTION_DAYS * 86_400_000);
}
//# sourceMappingURL=attachments.js.map